import { defineStore } from 'pinia'
import { computed, ref } from 'vue'

export const useTitleData = defineStore('titleData', () => {
  // state
  const titleName = ref('')
  const backPath = ref('')
  const backPrev = ref(false)
  const hasHelpButton = ref(false)
  const isHelpModalShown = ref(false)

  // actions
  function setTitleName(value) {
    titleName.value = value
  }

  function setBackPath(value) {
    backPath.value = value
  }

  function setBackPrev(value) {
    backPrev.value = value
  }

  function setHasHelpButton(value) {
    hasHelpButton.value = value
  }

  function setIsHelpModalShown(value) {
    isHelpModalShown.value = value
  }

  return {
    titleName,
    backPath,
    backPrev,
    hasHelpButton,
    isHelpModalShown,
    setTitleName,
    setBackPath,
    setBackPrev,
    setHasHelpButton,
    setIsHelpModalShown,
  }
})
